import type {Object3D} from 'three';
import type {SketchPointObject} from '../../../mesh/sketch/SketchPointObject';
import {addObject3DToParent} from '../../../utils/scene-object/addObject3DToParent';

/**
 * replacement Builder 注入端点的父级保护作用域。
 *
 * 样条构造器会在完成前接管控制点父级；构造失败时由本对象恢复既有 keeper 点归属。
 */
export class SketchReferenceInjectedEndpointParentScope {
	/** 注入点在构造前的父级。 */
	private readonly parentByPoint = new Map<SketchPointObject, Object3D | null>();

	/** @param points Builder 直接复用的既有端点。 */
	public constructor(points: readonly (SketchPointObject | undefined)[]) {
		points.forEach((point) => {
			if (point && !this.parentByPoint.has(point)) {
				this.parentByPoint.set(point, point.parent);
			}
		});
	}

	/** 恢复所有注入端点在构造前的父级。 */
	public restore(): void {
		this.parentByPoint.forEach((parent, point) => {
			if (!parent) {
				point.parent?.remove(point);
				return;
			}
			if (point.parent !== parent) {
				addObject3DToParent(point, parent);
			}
		});
	}
}
